import React from 'react';

import Button from '@/core/components/Button';
import Header from '@/core/components/Header';
import Image from '@/core/components/Image';
import useMutation from '@/core/hooks/useMutation';
import useOpenGive from '@/core/hooks/useOpenGive';
import { useEnvContext } from '@/core/lib/env/env.context';
import { ApiMethods } from '@/core/lib/fetch';
import { ApiVersions } from '@/core/lib/fetch/fetch';
import Query from '@/core/lib/new-architecture/query';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import { UsersHasControlResult } from '@/core/types/control';

interface WelcomeControlProps {}

const WelcomeControl: React.FC<WelcomeControlProps> = () => {
  const { t } = useTranslationContext(['common']);
  const { DONNONS_API_URL } = useEnvContext();
  const { onOpenGive } = useOpenGive();
  const { invalidateControl } = Query.user.useInvalidate();

  const mutation = useMutation<UsersHasControlResult, void>({
    apiDefinition: { method: ApiMethods.PUT, url: `${DONNONS_API_URL}${ApiVersions.V1}/user/control/welcome` },
    onSuccess: async () => {
      await invalidateControl();
    },
  });

  const onSubmit = async (isOnOpenGive?: boolean) => {
    await mutation.mutateAsync();
    if (isOnOpenGive) {
      onOpenGive();
      return;
    }
  };

  return (
    <div className="size-full">
      <Header content="" iconAfter="close" labelAfter={t('close', { ns: 'common' })} onAfter={() => onSubmit(false)} />
      <section className="my-7 flex flex-col items-center text-center">
        <Image className="mx-auto size-49" type="png" src="/assets/illustration/welcome.png" alt={t('components.welcome-modal.title', { ns: 'common' })} />
        <p className="text-title my-6 font-semibold text-content-primary">{t('components.welcome-modal.title', { ns: 'common' })}</p>
        <div className="w-full lg:w-82">
          <Button variant="give" type="button" onClick={() => onSubmit(true)}>
            {t('components.welcome-modal.give-button', { ns: 'common' })}
          </Button>
        </div>
      </section>
    </div>
  );
};

export default WelcomeControl;
